module.exports = __webpack_public_path__ + "opensans-italic.403dee4359ca42b1d096.woff";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/opensans/opensans-italic.woff
// module id = ../../../../../www/assets/fonts/opensans/opensans-italic.woff
// module chunks = styles